import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const getInventoryTakingSessions = async (params) => {
	const { data } = await axios.get(`${API_GO}/app/inventory-taking`, { params });
	return data;
};

export const getInventoryTakingLookups = async () => {
	const { data } = await axios.get(`${API_GO}/app/inventory-taking/lookups`);
	return data;
};

export const getInventoryTakingResults = async (sessionId) => {
	const { data } = await axios.get(`${API_GO}/app/inventory-taking/${sessionId}/results`);
	return data;
};

export const finalizeInventoryTaking = async (sessionId) => {
	const { data } = await axios.post(`${API_GO}/app/inventory-taking/${sessionId}/finalize`);
	return data;
};

export const exportInventoryTaking = async (sessionId) => {
	const response = await axios.get(`${API_GO}/app/inventory-taking/${sessionId}/export`, {
		responseType: "blob",
	});
	return response;
};
